import type { SystemSettingRoles } from '../../../../context/RoleContext';

export const generateRolesName = (
  roles: string[],
  tenancyRoles: SystemSettingRoles,
) => {
  if (roles.length === 0) return '';
  const roleNames: string[] = [];
  roles.forEach((role) => {
    if (tenancyRoles[role]) {
      roleNames.push(tenancyRoles[role].name);
    }
  });
  if (roleNames.length === 0) return '';
  return ` {${roleNames.join(', ')}}`;
};
